module.exports = __webpack_public_path__ + "static/media/25.e5d02e19.png";